import { watch, computed } from 'vue'
export function useWatchPropsItem<T>(
  props: T,
  key: keyof T,
  handle: (data?: any) => void | Promise<void>
): void {
  const watchItem = computed(() => props[key])
  watch(watchItem, () => {
    void handle(watchItem.value)
  })
}

export function useChildIframeMessageHandle(fn: (data: string) => void): void {
  window.watchMessage = (data: string) => {
    fn(data)
  }
}
